import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderPickupButton2 from './OrderPickupButton2'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          center
        >
          <CFView textCenter column center w="100%">
            <CFImage
              w="95%"
              src={mobileHeroText}
              alt="Sushi Story Japanese Restaurant Logo Title"
            />
            <CFView mt="15px">
              <OrderPickupButton />
            </CFView>
            {/* <CFView mt="5px">
              <OrderPickupButton2 />
            </CFView> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          center
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <CFView column center w="100%" maxWidth="1400px">
            <CFImage
              h="190px"
              src={heroText}
              alt="Sushi Story Japanese Restaurant Logo Title"
            />
            <CFView pt="15px">
              <OrderPickupButton />
            </CFView>
            {/* <CFView pt="10px">
              <OrderPickupButton2 />
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
